import { routes } from "@constants/routes";
import { Button, Modal, ModalBody, ModalContent, ModalProps } from "@heroui/react";
import { useNavigate } from "react-router-dom";

export type VerifyOrganizationModalProps = Pick<ModalProps, "isOpen" | "onClose" | "onOpenChange"> & {};

const VerifyOrganizationModal: React.FC<VerifyOrganizationModalProps> = ({ isOpen, onClose, onOpenChange }) => {
  const navigate = useNavigate();

  const handleVerify = () => {
    navigate(`${routes.profile.main}?tab=verify`);
    onClose?.();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} onOpenChange={onOpenChange} size="3xl" hideCloseButton>
      <ModalContent className="p-4">
        <ModalBody className="flex items-center gap-8">
          <img
            src="https://img.icons8.com/bubbles/500/instagram-verification-badge.png"
            alt="verify-organization"
            className="w-48 h-48"
          />
          <p className="text-green-600 text-sm">Your company identity information has been successfully registered.</p>
          <p className="text-lg font-semibold">To complete the registration process, verify the company's identity.</p>
          <div className="flex gap-3 flex-col md:flex-row w-full">
            <Button color="success" className="w-full text-lg" onPress={handleVerify}>
              Authentication Now
            </Button>
            <Button
              variant="bordered"
              className="w-full text-lg border-2 border-yellow-500 text-yellow-500"
              onPress={onClose}
            >
              Later
            </Button>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
export default VerifyOrganizationModal;
